import React, { Component } from "react";
import "./SubTopicList.scss";
import { ReactComponent as LocationIcon } from "../../../../../assets/svg/location-icon.svg";
import { ReactComponent as PlayIcon } from "../../../../../assets/svg/play-icon.svg";
import { ReactComponent as PauseIcon } from "../../../../../assets/svg/pause-icon.svg";
import { ReactComponent as MoreIcon } from "../../../../../assets/svg/more-icon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/svg/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/svg/delete.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import moment from "moment";

export default class SubTopicList extends Component {
    constructor(props) {
        super(props);
    }
    getCountries = (location) => {
        try {
            let countries = this.props.allLocations || [];
            let countryList = location.trim().split(",");
            let allcountriesName = "";
            for (let i = 0; i < countryList.length; i++) {
                let countryInfo = countries.filter((x) => x.short_name == countryList[i].trim());
                allcountriesName += countryInfo[0].name;
                if (i < countryList.length - 1) {
                    allcountriesName += ", ";
                }
            }
            if (allcountriesName == " ") {
                allcountriesName = "WorldWide";
            }
            return allcountriesName || "WorldWide";
        } catch (e) {
            return "WorldWide";
        }
    };
    getAccountsInfo(accounts) {
        let accountData = accounts;
        if (accountData === null) {
            return "-";
        }
        let accountsVal = "";
        let tiktokKeyword = "";
        JSON.parse(accountData).forEach((ele) => {
            if (ele?.config_type === "tiktok_account") {
                const account = ele;
                let string = `tiktok:${account.query_filter},fetch_comment:0,news_config:0`;
                if (account.location_short_name) {
                    string += `,country:${account.location_short_name}`;
                }
                if (account.entity_sub_type) {
                    string += `,entity_sub_type:${account.entity_sub_type},`;
                }

                accountsVal += "\n" + string;
            } else if (ele?.config_type === "tiktok") {
                if (!tiktokKeyword) tiktokKeyword = ele.query_filter;
                else tiktokKeyword = tiktokKeyword + " OR " + ele.query_filter;
                return;
            } else {
                try {
                    if (JSON.parse(ele)?.keywords) return;
                } catch (e) {
                    if (ele.value.indexOf("youtube_url:") > -1 && ele.value.indexOf("youtube:") > -1) {
                        accountsVal += "\n" + ele.value.split(",").slice(1).join(",");
                    } else accountsVal += "\n" + ele.value;
                }
            }
        });

        if (tiktokKeyword) accountsVal += `\ntiktokKeyword: ${tiktokKeyword}`;

        return accountsVal || "-";
    }

    getPostsInfo(posts) {
        if (posts === null) {
            return "-";
        }
        let result;
        let postList = [];

        JSON.parse(posts).forEach((ele) => {
            try {
                if (JSON.parse(ele)?.keywords) {
                    let posts = JSON.parse(ele)?.keywords;
                    posts.map((post) => postList.push(post.post_url));
                }
            } catch (e) {
                return;
            }
        });
        if (postList.length === 0) result = "-";
        else result = { posts: postList, length: postList.length };

        return result;
    }

    getSubtopicName = (ac) => {
        if (ac.topic_name === "FB_COMMENTS") {
            const postArr = ac.subtopic_name.split("_");
            return postArr[postArr.length - 1];
        } else return ac.subtopic_name;
    };

    render() {
        return (
            <div className="subTopic">
                {this.props.ele.sub_topics.map((elem, id) => {
                    let postInfo = this.getPostsInfo(elem.accounts);
                    let postLength, posts;
                    if (postInfo !== "-") {
                        postLength = postInfo.length;
                        posts = postInfo.posts;
                    }
                    return (
                        <div className="table__row" key={id}>
                            <div className="topic_name" title="Subtopic">
                                <span className={`status__color`} style={{ backgroundColor: elem.subtopic_graph_color || "#FF0000" }}></span>{" "}
                                {this.getSubtopicName(elem)}
                            </div>
                            <div className="boolean__query" title="Boolean Query">
                                {elem.boolean || "-"}
                            </div>
                            <div className="location">
                                <Popup trigger={<LocationIcon />} content={this.getCountries(elem.countries)} size="mini" position="left center" inverted />
                            </div>
                            <div className="account_name" title="Account details">
                                {this.getAccountsInfo(elem.accounts)}
                            </div>
                            <div className="posts" title="Facebook Posts">
                                {postInfo === "-" ? (
                                    "-"
                                ) : (
                                    <Popup
                                        trigger={<span className="postsPopupTrigger">{postLength}</span>}
                                        content={
                                            <div className="postsPopupContent">
                                                <p>Note*: All comments from these posts are being fetched.</p>
                                                <div className="postsPopupOptions">
                                                    {posts.map((post, ind) => (
                                                        <p style={{ margin: 0 }} key={ind}>
                                                            {post}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                        }
                                        size="mini"
                                        className="postsPopup"
                                        position="left center"
                                        inverted
                                        on="click"
                                    />
                                )}
                            </div>
                            <div className="added_on">
                                {elem.created_date ? (
                                    <Popup
                                        trigger={<span>{moment(elem.created_date).format("YYYY-MM-DD")}</span>}
                                        content={moment(elem.created_date).tz(this.props.userTimeZone).format("YYYY-MM-DD HH:mm:ss z")}
                                        size="mini"
                                        position="right center"
                                        inverted
                                    />
                                ) : (
                                    "-"
                                )}
                            </div>
                            <div className="query_status">
                                {elem.data_fetch_enabled !== 2 ? (
                                    !elem.is_historical_tagged && elem.tokenized_details ? (
                                        <span title="Processing" className="processing-text">
                                            Processing
                                        </span>
                                    ) : (
                                        <span title="Active" className="active-text">
                                            Active
                                        </span>
                                    )
                                ) : (
                                    <span title="Paused" className="inactive-text">
                                        Paused
                                    </span>
                                )}
                            </div>
                            <span className="delete_query">
                                {elem.data_fetch_enabled !== 0 ? (
                                    elem.data_fetch_enabled === 1 ? (
                                        <PauseIcon
                                            disabled={this.props.packageObj.package_code == "free"}
                                            title="Click to Disable Data Fetch"
                                            onClick={() => this.props.disableDataPull(elem)}
                                        />
                                    ) : (
                                        <PlayIcon
                                            disabled={this.props.packageObj.package_code == "free"}
                                            title="Click to Enable Data fetch"
                                            onClick={() => this.props.enableDataPull(elem)}
                                        />
                                    )
                                ) : (
                                    ""
                                )}
                            </span>

                            <span className="more__action">
                                <Popup
                                    trigger={<MoreIcon title="Actions" />}
                                    content={
                                        <div className="modal-wrap">
                                            <div
                                                className="modal-row"
                                                onClick={() => this.props.handlEditQuery(elem)}
                                                style={{ cursor: "pointer" }}
                                                title="Click to edit topic">
                                                <EditIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                Edit
                                            </div>
                                            <Popup
                                                inverted
                                                content={
                                                    elem.data_fetch_enabled === 1 ? "Please pause the rule first to delete the query" : "Click to delete query"
                                                }
                                                trigger={
                                                    <div
                                                        className="modal-row"
                                                        onClick={() => {
                                                            if (elem.data_fetch_enabled === 1) return;
                                                            else this.props.handleDelete(elem);
                                                        }}
                                                        style={
                                                            elem.data_fetch_enabled === 1 ? { cursor: "not-allowed", opacity: "0.4" } : { cursor: "pointer" }
                                                        }>
                                                        <DeleteIcon style={{ height: "14px", width: "14px", marginRight: "4px" }} />
                                                        Delete
                                                    </div>
                                                }
                                            />
                                        </div>
                                    }
                                    on="click"
                                    size="small"
                                    position="right center"
                                />
                            </span>
                        </div>
                    );
                })}
            </div>
        );
    }
}
